import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import Carousel from './Carousel';
import yellowWoman from '../../assets/server-room-temperature-monitoring.jpg';
import AIMix from '../../assets/serverBlue.jpeg';
import AbtImage from '../../assets/bluepic2.png';
import Mission from './Mission';

const AboutUsHome = () => {
  const features = [
    "24/7 service desk provides round the clock critical support to all our customers",
    "Strict Service Level Agreements and Online Ticketing Tool",
    "Dedicated Account Managers to escalate high priority cases",
    "Certified engineers provides unlimited remote support and 24/7 onsite critical support",
    "Well defined call classification and escalation matrix",
    "As a CSR initiative, we extend support to non-customers (in case of any IT emergency)"
  ];
  const items = [
    {
      title: 'Innovative',
      description: 'We encourage learning and development to offer innovative ICT Solutions.',
      icon: 'innovative', // Should match the key in icons object in CarouselItem
    },
    {
      title: 'Committed',
      description: 'We are committed to fulfill the promise given, by focusing and ensuring value delivery.',
      icon: 'committed',
    },
    {
      title: 'Together',
      description: 'We work for a common purpose with a shared vision and a collaborative model.',
      icon: 'together',
    },
    {
      title: 'Integrity',
      description: 'We operate with full transparency in all aspects of our relationships.',
      icon: 'integrity',
    },
    {
      title: 'Care',
      description: 'We deeply care about our staff, customers, and the ecosystem in which we are in.',
      icon: 'care',
    },
  ];

  return (
    <section className="py-16">
     <div className="relative py-24 bg-cover bg-center bg-no-repeat" >
        <div className="absolute inset-0 bg-black opacity-80" 
            style={{
              backgroundImage: `url(${yellowWoman})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              zIndex: '-1',  // Background remains behind the text
            }}>
        </div>
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-6xl font-bold text-white">
            About Us
          </h1>
          <p className="text-lg md:text-2xl text-white mt-4 animate-fadeIn delay-2s">
            Driving digital transformation with innovative IT solutions
          </p>
        </div>
      </div>
      
      <div className="bg-gray-100 flex flex-col md:flex-row items-center mt-8  p-5">
      <img src={AIMix} alt="About Us" className="rounded-lg w-full md:w-1/2 md:mt-0" style={{ height: '300px', objectFit: 'cover'}} /> <br />
        <div className="md:ml-8 flex-1 mt-2 md:mt-0 flex-1 mr-5 text-justify h-full">
        <h1 className='text-[#023B8D] text-center text-justify lg:text-2xl sm:text-md mt-0 font-semibold'>Who we are</h1> 
        <hr className='my-4 border-blue-300' />
          <p className="mt-4 md:mt-0 text-md md:text-md text-justify">
            We are an information technology integration and management agency based in
            Lusaka, Zambia. Registered in 2012, we deliver bespoke technology integration solutions
            through research, business-case and process analysis, deployment of IT infrastructure,
            and integration of data analytics. 
          </p>
          <p className="mt-4 text-md md:text-md text-justify">
            We specialize in IT Consultancy, Technology Solution Design, Project implementation and Support Services
            to various industry verticals. Our team includes dedicated and 
            certified engineers proficient in Networking, Security, Virtualization, Software Development, and Server Management. 
            We assist clients in overcoming challenges.
          </p>
        </div>
      </div>
      <Mission/>
      <div className="justify-between  p-5">
        <h1 className='text-lg lg:text-2xl font-semibold mb-4 text-center my-2 text-[#023B8D]'>Our Values</h1>
        <h1 className='text-lg lg:text-4lg font-semibold mb-4 text-center text-[#023B8D]'>Know About us all</h1>
        <Carousel items={items} />
      </div>
      <div className="flex flex-col lg:flex-row justify-between mt-8 items-start p-5">
        <div className="lg:w-1/2 mt-8 lg:mt-0 order-2 lg:order-1">
          <div className="border border-blue-300 rounded-lg p-5 shadow-lg h-full">
            <h2 className="text-md lg:text-md font-semibold mb-4 text-[#023B8D]">Why We are Unique:</h2>
            <ul className="list-none">
              {features.map((feature, index) => (
                <li key={index} className="flex items-start mb-2">
                  <FontAwesomeIcon icon={faCheckCircle} className="text-[#C5B358] mt-1 mr-2" />
                  <span className="text-md md:text-lg">{feature}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="relative flex-1 ml-0 lg:ml-5 text-justify order-1 lg:order-2">
          {/* Main Image */}
          <img 
            src={AbtImage}
            alt="AbtImage" 
            className="relative w-full h-full object-cover rounded-md shadow-lg z-10 transition-transform duration-500 ease-in-out transform hover:scale-105"
            style={{ maxHeight: '100%' }} // Ensures the image does not exceed the height of the container
          />
        </div>
      </div>
    
    <div className="bg-white py-12 p-5">
        <div className="container mx-auto text-center">
          <h2 className="text-lg md:text-xl font-semibold text-[#023B8D] mb-6 animate-bounce">
            Ready to Transform Your Business?
          </h2>
          <p className="text-gray-700 text-lg md:text-xl mb-8 animate-fadeIn delay-1s">
            Get in touch with us to start your digital transformation journey.
          </p>
          <Link to="/ContactPage">
            <button className="bg-[#C5B358] text-blue-900 font-semibold py-3 px-8 rounded-full transition duration-300 hover:bg-[#c39e2a] hover:scale-110 animate-pulse">
              Contact Us
            </button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default AboutUsHome;

